import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from "../../images/caobangceritage.svg"
import BotChatGPT from '../ChatbotPopUp';
import AiVoice from '../../components/AiVoice/AiVoice';
const ContactPage =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo}/>
            <PageTitle pageTitle={'Liên hệ tác giả'} pagesub={'Liên hệ'}/> 
            <Contactpage/>
            <Footer/>
            <AiVoice />
             <BotChatGPT />
        </Fragment>
    )
};
export default ContactPage;

